import PropTypes from 'prop-types'
import CloseIcon from '@material-ui/icons/Close'
import IconButton from '@material-ui/core/IconButton'
import { TextField } from '@material-ui/core'

import { Colors } from '~/styles'
import { Button } from '~/components'

import Styled from './confirm-assignment-modal.styled'
import useConfirmAssignmentModal from './confirm-assigment-modal.hooks'

const ConfirmAssignmentModal = ({ data, methods }) => {
  const {
    methods: { handleUpdate },
    data: { error }
  } = useConfirmAssignmentModal({ data, methods })

  return (
    <Styled.ConfirmDialog
      id='mdl_vessel_forecast_confirm_overlap_dialog'
      open={data.isOpenConfirmAssignment}
      width={30}
      onClose={methods.handleCloseForm}
      maxWidth='md'
      fullWidth={true}
      aria-labelledby='mdl_vessel_forecast_confirm_overlap_dialog'
      disableEnforceFocus={true}
      disableBackdropClick={true}
    >
      <Styled.ConfirmHeader>
        <Styled.ConfirmTitle>
          Confirmation Required to Close Assignment
        </Styled.ConfirmTitle>
        <div
          id='modal-button'
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <IconButton
            onClick={methods.handleCloseForm}
            aria-label='close'
            id='mdl_dialog_x_btn'
          >
            <CloseIcon htmlColor={Colors.cancelTextColor} />
          </IconButton>
        </div>
      </Styled.ConfirmHeader>
      <Styled.ConfirmContent>
        <Styled.ConfirmDesc>
          Please provide a reason for closing this vessel forecast assignment
        </Styled.ConfirmDesc>
        <TextField
          id='mdl_vessel_forecast_confirm_assignment_remarks'
          name='remarks'
          value={data.remarks}
          maxRows={5}
          minRows={4}
          variant='outlined'
          multiline={true}
          hiddenLabel={true}
          aria-label='remarks'
          placeholder='Enter closing reason here...'
          style={{ width: '100%' }}
          error={error}
          onChange={methods.handleChangeRemarks}
        />
      </Styled.ConfirmContent>
      <Styled.ConfirmAction>
        <Button
          color='white'
          onClick={methods.handleCloseForm}
          borderColor={Colors.softBlue}
        >
          Close
        </Button>
        <Button color='blue' onClick={handleUpdate}>
          Update
        </Button>
      </Styled.ConfirmAction>
    </Styled.ConfirmDialog>
  )
}

ConfirmAssignmentModal.propTypes = {
  data: PropTypes.shape({
    remarks: PropTypes.string.isRequired,
    isOpenConfirmAssignment: PropTypes.bool.isRequired
  }),
  methods: PropTypes.shape({
    handleUpdate: PropTypes.func.isRequired,
    handleCloseForm: PropTypes.func.isRequired,
    handleChangeRemarks: PropTypes.func.isRequired
  })
}

export default ConfirmAssignmentModal
